"use strict";

(function () {
  'use strict';

  angular.module('lm.Request', []).directive('lmRequest', ['$window', '$uibModal', '$http', 'api', '$lrNotifier', function ($window, $uibModal, $http, api, $lrNotifier) {
    return {
      restrict: 'E',
      scope: {
        property: '<',
        transactions: '<'
      },
      template: '<button type="button" class="btn" ng-click="$ctrl.issueRequest()" uib-tooltip="Create LiveManager Work Order Request"><i class="fa fa-file-text-o"></i></button>',
      controller: function lmRequestCtrl() {
        var vm = this;

        vm.issueRequest = function () {
          var modalInstance = $uibModal.open({
            templateUrl: 'app/properties/request/request.modal.html',
            controller: 'IssueRequestCtrl',
            resolve: {
              modalData: function modalData() {
                return {
                  property: vm.property,
                  transactions: vm.transactions
                };
              }
            }
          });
          modalInstance.result.then(function (result) {
            if (result) {
              result['pid'] = vm.property ? vm.property.pid : '';
              $http.post(api.proxy + '/work-orders/request', result).success(function (data) {
                $lrNotifier.content('Request Submitted').show();
              }).error(function (data) {
                $lrNotifier.content('Error Submitting Request').show();
              });
            }
          }, function () {});
        };
      },
      controllerAs: '$ctrl',
      bindToController: true
    };
  }]).controller('IssueRequestCtrl', ['$uibModalInstance', '$scope', 'User', 'modalData', '$lrNotifier', function ($uibModalInstance, $scope, User, modalData, $lrNotifier) {
    $scope.err = '';
    $scope.data = {};
    $scope.property = modalData.property;
    $scope.data.priority = 2;
    var token = User.getToken();

    if (modalData.property) {
      $scope.data.pageDataId = modalData.property.pageDataID;
    }

    if (modalData.property && modalData.property.transactions) {
      $scope.data.transactionId = modalData.property.transactions[0].TransactionID;
    }

    $scope.submit = function () {
      $scope.err = '';

      if (!$scope.data.description) {
        $scope.err = 'Please Describe the Issue';
        return;
      }

      $uibModalInstance.close($scope.data);
      $lrNotifier.content('Loading...').show();
    };

    $scope.cancel = function () {
      $uibModalInstance.close();
    };

    $scope.open = function ($event) {
      $event.preventDefault();
      $event.stopPropagation();
      $scope.opened = true;
    };
  }]);
})();